import React from 'react';
import '../assets/css/components/sandbox-activity-card.css';

const SandboxActivityCard = ({ activity, onClick }) => {
  return(
    <div onClick={onClick} className="col-sm-12 col-md-6 col-lg-3 m-b-10 sandbox-activity-card">
      <div className='ar-1-1'>
        <div className='card no-border bg-primary widget widget-loader-circle-lg no-margin'>
          <div className="card-block">
            <div className="pull-bottom bottom-left bottom-right padding-25">
              <br/>
              <p className="content-name text-white">{activity.title}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SandboxActivityCard
